import { render, staticRenderFns } from "./PrismCode.vue?vue&type=template&id=f3749532&"
import script from "./PrismCode.vue?vue&type=script&lang=ts&"
export * from "./PrismCode.vue?vue&type=script&lang=ts&"
import style0 from "./PrismCode.vue?vue&type=style&index=0&id=f3749532&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.10.1_css-loader@6.7.1_lodash@4.17.21_vue-template-compiler@2.7.14_webpack@5.73.0/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports